(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["youngs-bulk-order-page"] && !Shopify.designMode) return;
  try {
    const bulkOrderProducts = document.querySelector('#BulkOrderProducts');
  const bulkOrderProduct = new URLSearchParams(window.location.search).get('product');
  if (bulkOrderProducts && bulkOrderProduct && bulkOrderProducts.value.trim() === '') {
    bulkOrderProducts.value = `${bulkOrderProducts.dataset.productPrefix}: ${bulkOrderProduct.replaceAll('-', ' ')}`;
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["youngs-conversion-layer"] && !Shopify.designMode) return;
  try {
    (() => {
    const contextElement = document.getElementById('YoungsConversionContext');
    let context = {};
    try {
      context = JSON.parse(contextElement?.textContent || '{}');
    } catch (error) {
      context = {};
    }

    const toNumber = (value) => {
      const number = Number(value);
      return Number.isFinite(number) ? number : 0;
    };

    const normalizeItem = (item = {}) => ({
      item_id: String(item.item_id || ''),
      item_variant: String(item.item_variant || ''),
      item_name: String(item.item_name || ''),
      price: toNumber(item.price),
      quantity: Math.max(1, Math.round(toNumber(item.quantity) || 1)),
    });

    const cartLineToItem = (line = {}) => ({
      item_id: line.product_id || line.product?.id || line.item_id,
      item_variant: line.variant_id || line.variant?.id || line.id || line.item_variant,
      item_name: line.product_title || line.product?.title || line.item_name || line.title,
      price: toNumber(line.final_price ?? line.price) / 100,
      quantity: line.quantity || 1,
    });

    const buildEcommerce = (rawItems = []) => {
      const items = rawItems.map(normalizeItem).filter((item) => item.item_id && item.item_name);
      if (!items.length) return null;
      const value = items.reduce((total, item) => total + item.price * item.quantity, 0);
      return {
        currency: 'ZAR',
        value: Number(value.toFixed(2)),
        items: items,
      };
    };

    const emitPayload = (payload) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent('youngs:conversion', { detail: payload }));
    };

    const pageContext = {
      page_type: context.page_type || null,
      template: context.template || null,
      collection_handle: context.collection_handle || null,
    };

    const emitCommerce = (name, rawItems, detail = {}) => {
      const ecommerce = buildEcommerce(rawItems);
      if (!ecommerce || !ecommerce.items.length) return;
      emitPayload({ event: `youngs_${name}`, ecommerce, page_context: pageContext, ...detail });
    };

    const emitInteraction = (name, detail = {}) => {
      emitPayload({ event: `youngs_${name}`, page_context: pageContext, ...detail });
    };

    let lastCartItems = Array.isArray(context.cart) ? context.cart.map(normalizeItem) : [];

    const replaceCartItems = (lines) => {
      lastCartItems = Array.isArray(lines) ? lines.map(cartLineToItem).map(normalizeItem) : lastCartItems;
    };

    const mergeAddedItem = (item) => {
      const normalized = normalizeItem(item);
      const existing = lastCartItems.find((cartItem) => cartItem.item_variant === normalized.item_variant);
      if (existing) {
        existing.quantity += normalized.quantity;
      } else {
        lastCartItems.push(normalized);
      }
    };

    let cartUpdateSubscribed = false;
    const subscribeToCartUpdates = () => {
      if (cartUpdateSubscribed) return true;
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;

      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const cartData = event?.cartData;
        if (Array.isArray(cartData?.items)) replaceCartItems(cartData.items);
        if (event.source !== 'product-form' || !cartData) return;

        const addedItem = cartLineToItem({
          ...cartData,
          quantity: event.quantity || cartData.quantity || 1,
        });
        mergeAddedItem(addedItem);
        emitCommerce('add_to_cart', [addedItem]);
        if (event.skipCart) emitCommerce('begin_checkout', lastCartItems);
      });
      cartUpdateSubscribed = true;
      return true;
    };

    if (!subscribeToCartUpdates()) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', subscribeToCartUpdates, { once: true });
      } else {
        setTimeout(subscribeToCartUpdates, 0);
      }
    }

    const refreshCartItems = async () => {
      const cartRequest = fetch('/cart.js', { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null);
      const timeout = new Promise((resolve) => setTimeout(() => resolve(null), 300));
      const cartData = await Promise.race([cartRequest, timeout]);
      if (Array.isArray(cartData?.items)) {
        replaceCartItems(cartData.items);
        return lastCartItems;
      }
      return null;
    };

    const trackCheckout = async () => {
      const refreshedItems = await refreshCartItems();
      emitCommerce('begin_checkout', refreshedItems || lastCartItems);
    };

    const resumeFormSubmission = (form, submitter) => {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter);
        return;
      }

      if (submitter?.name) {
        const submitterValue = document.createElement('input');
        submitterValue.type = 'hidden';
        submitterValue.name = submitter.name;
        submitterValue.value = submitter.value;
        form.appendChild(submitterValue);
      }
      HTMLFormElement.prototype.submit.call(form);
    };

    if (context.product) emitCommerce('view_item', [context.product]);

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const tracked = target.closest('[data-youngs-event]');
      if (tracked) {
        emitInteraction(tracked.dataset.youngsEvent, {
          destination: tracked.getAttribute('href') || null,
        });
      }

      const productLink = target.closest('.product-card-wrapper a[data-youngs-product-id]');
      if (productLink) {
        emitCommerce('select_item', [{
          item_id: productLink.dataset.youngsProductId,
          item_variant: productLink.dataset.youngsVariantId,
          item_name: productLink.dataset.youngsProductTitle,
          price: productLink.dataset.youngsPrice,
          quantity: 1,
        }], { destination: new URL(productLink.href).pathname });
      }

      const checkoutLink = target.closest('a[href*="/checkout"]');
      if (!checkoutLink || checkoutLink.dataset.youngsCheckoutPending === 'true') return;
      event.preventDefault();
      checkoutLink.dataset.youngsCheckoutPending = 'true';
      trackCheckout().finally(() => window.location.assign(checkoutLink.href));
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      if (form.matches('form[action*="/search"]')) emitInteraction('search_submit');

      const submitter = event.submitter;
      const isCheckout = submitter?.matches('[name="checkout"], #checkout');
      if (!isCheckout) return;
      if (form.dataset.youngsCheckoutResume === 'true') {
        delete form.dataset.youngsCheckoutResume;
        return;
      }

      event.preventDefault();
      form.dataset.youngsCheckoutResume = 'true';
      trackCheckout().finally(() => resumeFormSubmission(form, submitter));
    }, true);

    document.addEventListener('change', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (target?.closest('facet-filters-form, .facets')) {
        emitInteraction('filter_change', { filter: target.getAttribute('name') || null });
      }
    });

    if (context.page_type === 'search' && new URLSearchParams(window.location.search).has('q')) {
      emitInteraction(document.querySelector('.template-search--empty') ? 'zero_result_search' : 'search_results_view');
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
